// src/apiServices/partsCatalogStatusApi.ts
import api from "../api";
import type { MasterStatusListDto } from "../models/MasterStatus";

type ApiResponse<T> = { statusCode: number; message?: string; data?: T };

// GET: items + full status catalog (by role)
export async function fetchMastersWithStatus(
  oem: string,
  role: string
): Promise<MasterStatusListDto> {
  const { data } = await api.get<ApiResponse<MasterStatusListDto>>(
    `/Parts/componentsManual/by-role-status/${oem}/${role}`
  );
  if (data?.statusCode === 200 && data.data) return data.data;
  return { statuses: [], items: [] };
}

// PATCH: update a workspace's status
export async function updateWorkspaceStatus(
  oem: string,
  workspaceAssemblyId: number,
  statusId: number
): Promise<ApiResponse<null>> {
  const { data } = await api.patch<ApiResponse<null>>(
    `/Parts/workspace/status/${oem}/${workspaceAssemblyId}`,
    { statusId }
  );
  return data;
}